import React from 'react';
import PropTypes from 'prop-types';
import { statuses } from '../index';
import InlineCallOut from '../../inline-callout/inline-callout';

const WebchatInlineCallout = ({ config, status, ...rest }) => (
  <InlineCallOut {...rest}>
    <p>{config[`statusDescription${status}`]}</p>
  </InlineCallOut>
);

WebchatInlineCallout.propTypes = {
  status: PropTypes.oneOf(Object.values(statuses)),
  config: PropTypes.object,
};

export default WebchatInlineCallout;
